export enum UserActionTypes {
    LIST_REQUEST = '@@User/LIST_REQUEST',
    LIST_SUCCESS = '@@User/LIST_SUCCESS',
    LIST_ERROR = '@@User/LIST_ERROR',
    LIST_CLEAR = '@@User/LIST_CLEAR',

    SELECT = '@@User/SELECT',
    SELECTED = '@@User/SELECTED',
    CLEAR_SELECTED = '@@User/CLEAR_SELECTED',
    
    CREATE_REQUEST = '@@User/CREATE_REQUEST',
    CREATE_SUCCESS = '@@User/CREATE_SUCCESS',
    CREATE_ERROR = '@@User/CREATE_ERROR',
    
    READ_REQUEST = '@@User/READ_REQUEST',
    READ_SUCCESS = '@@User/READ_SUCCESS',
    READ_ERROR = '@@User/READ_ERROR',

    UPDATE_REQUEST = '@@User/UPDATE_REQUEST',
    UPDATE_SUCCESS = '@@User/UPDATE_SUCCESS',
    UPDATE_ERROR = '@@User/UPDATE_ERROR',
    
    DELETE_REQUEST = '@@User/DELETE_REQUEST',
    DELETE_SUCCESS = '@@User/DELETE_SUCCESS',
    DELETE_ERROR = '@@User/DELETE_ERROR',

    RESETPASSWORD_REQUEST = '@@User/RESETPASSWORD_REQUEST',
    RESETPASSWORD_SUCCESS = '@@User/RESETPASSWORD_SUCCESS',
    RESETPASSWORD_ERROR = '@@User/RESETPASSWORD_ERROR',
    
    DOWNLOAD_REQUEST = '@@User/DOWNLOAD_REQUEST',
    DOWNLOAD_SUCCESS = '@@User/DOWNLOAD_SUCCESS',
    DOWNLOAD_ERROR = '@@User/DOWNLOAD_ERROR',
}

export interface UserUIState {
    readonly loading: boolean
    readonly searchParams?: any
    readonly processing: boolean // For CRUD Operation
    readonly processState: number
    readonly selected?: string
    readonly errors?: string []
    readonly isConflict : boolean
    readonly totDoc?: number
    readonly downloading: boolean
    readonly downloadURL : string
}
